import ItemFilterBar from "../../CommonElements/Table/ItemFilterBar";
import SearchBar from "../../CommonElements/Table/SearchBar";

/**
 * Function for Subheader component of components, usually have filters.
 * @param {function} handleSearch(e) Variable for enabling search and handle search value. Use SearchBar component. e: Event.
 * @param {function} handleFilter(e, key) Variable for enabling filter and handle filter value. Use ItemFilterBar component. e: Event, key: key in the listData.
 * @param {dictionary} listData Variable for enabling filter and values for options. Example,
 * {
        [key]: {
          label: "Filter Label",
          data: <-- data -->,
          featureName: <-- attribute of data  for filtering -->,
          col: (optional) size of column for flex,
        },
      }
 * @returns a layout of search and filter bar as Subheader component
 */
const SubHeaderComponentLayout = ({ handleSearch, handleFilter, listData }) => {
  return (
    <div
      className={`row row-cols-4 justify-content-${
        handleFilter && listData ? "between" : "end"
      } align-items-end`}
    >
      {handleFilter &&
        listData &&
        Object.entries(listData).map(([key, value]) => {
          return (
            <ItemFilterBar
              className={`col-${value?.col}` || "col"}
              label={value?.label}
              options={value?.data?.map((item) => ({
                id: item[value?.id],
                value: item[value?.featureName],
              }))}
              onChange={(e) => handleFilter(e, key)}
            />
          );
        })}
      {handleSearch && <SearchBar className="col" onChange={handleSearch} />}
    </div>
  );
};

export default SubHeaderComponentLayout;
